import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InterceptorErrorComponent } from './interceptor-error/interceptor-error.component';
import { ToastsService, LoaderService } from 'up';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private toastsService: ToastsService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let JWTToken;

    if (
      request.url.includes('assets/i18n') ||
      request.url.includes('assets/quid-i18n')
    ) {
      return next.handle(request);
    }

    try {
      this.toastsService.clear();
      if (sessionStorage.getItem('JWT') != '') {
        JWTToken = sessionStorage.getItem('JWT');
      }
    } catch (e) {}

    let headerObj = {
      'Content-Type': 'application/json',
      authorization: 'Bearer ' + JWTToken,
      'Access-Control-Allow-Origin': '*',
    };

    request = request.clone({
      setHeaders: headerObj,
      url: request.url,
    });
    if (!request.url.includes('activity/assessment/item/update')) {
      this.loaderService.show();
    }
    return next.handle(request).pipe(
      tap((res) => {
        if (res instanceof HttpResponse) {
          if (res.headers.get('authorization'))
            sessionStorage.setItem(
              'JWT',
              res.headers.get('authorization')?.split(' ')[1] || ''
            );
        }
      }),
      catchError((error: HttpErrorResponse) => {
        let tokenErrorHeader = '';
        let tokenErrorBody = '';
        let showErrorModal = false;
        this.modalService.dismissAll();
        let tokenError: boolean = false;
        switch (error.error.errorCode) {
          case 'TOKEN_INVALID':
            tokenErrorHeader = 'GENERIC.MODAL.INVALID_TOKEN_HEADER';
            tokenErrorBody = 'GENERIC.MODAL.INVALID_TOKEN_MSG';
            showErrorModal = true;
            tokenError = true;
            break;
          case 'TOKEN_EXPIRED':
            tokenErrorHeader = 'GENERIC.MODAL.EXPIRED_TOKEN_HEADER';
            tokenErrorBody = 'GENERIC.MODAL.EXPIRED_TOKEN_MSG';
            showErrorModal = true;
            tokenError = true;
            break;
        }
        // if (!this.sharedService.getTokenError() && showErrorModal) {
        //   this.sharedService.setTokenError();
        if (tokenError) {
          let modalRef = this.modalService.open(InterceptorErrorComponent, {
            size: 'md',
            keyboard: false,
            backdrop: 'static',
            centered: true,
          });
          modalRef.componentInstance.modalTitle = tokenErrorHeader;
          modalRef.componentInstance.modalBody = tokenErrorBody;
        }
        // }
        return throwError(error);
      }),
      finalize(() => {
        this.loaderService.hide();
      })
    );
  }
}
